<template>
  <div>
    <div class="sub_visual_wrap">
      <div class="sub_visual_box container">
        <div class="page_nav">
          <ul>
            <li>
              <router-link to="/main" @click.native="$store.commit('setActive', '')">{{
                $t("common.home")
              }}</router-link>
            </li>
            <li>
              <a href="#">{{ $t("common.management") }}</a>
            </li>
          </ul>
        </div>
        <h2>{{ $t("common.management") }}</h2>
      </div>
    </div>
    <section class="container">
      <div class="sub_contents_wrap">
        <div class="fillter_p_wrap">
          <div class="wrap_con">
            <div class="left_con">
              <div class="fillter_left_box">
                <h4>
                  <span>Management</span
                  ><a href="#" class="l_fillter_bt"><em>Library Management</em></a>
                </h4>
                <div class="fillter_inner">
                  <div
                    v-for="(pmenu, index) in parentMenu"
                    :key="index"
                    class="fillter_group_box"
                    :class="{ f_g_active: $store.state.componentName == pmenu.label }"
                  >
                    <p @click="showMenu(pmenu.label)">
                      <a href="javascript:void(0)">{{ pmenu.label }}</a>
                    </p>
                    <span v-show="$store.state.componentName == pmenu.label">
                      <div
                        v-for="(cmenu, index) in childMenu"
                        :key="index"
                        class="category_list"
                      >
                        <ul v-if="pmenu.menuId == cmenu.parentMenuId">
                          <li>
                            <router-link
                              :to="cmenu.menuUrl"
                              @click.native="[setMenuLabel(cmenu.label)]"
                              :class="menuLabel == cmenu.label ? 'on' : ''"
                              >{{ cmenu.label }}</router-link
                            >
                          </li>
                        </ul>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="middle_con">
              <router-view></router-view>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getManagementMenuList } from "@/api/menu";
export default {
  data() {
    return {
      parentMenu: [],
      childMenu: [],
      showYN: "",
      storeId: "",
      menuLabel: "",
    };
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await getManagementMenuList();
        this.parentMenu = data.parentMenu;
        this.childMenu = data.childMenu;
      } catch (error) {
        console.log(error);
      }
    },
    showMenu(label) {
      if (this.showYN == label) {
        this.$store.commit("setComponentName", "");
        this.showYN = "";
        return;
      }
      this.$store.commit("setComponentName", label);

      this.$store.commit("setPage", 1);
      this.$store.commit("setSearchWord", "");
      this.$store.commit("setSearchObj", "");
      this.showYN = label;
    },
    setMenuLabel(label) {
      this.$store.commit("setPage", 1);
      this.$store.commit("setSearchWord", "");
      this.$store.commit("setSearchObj", "");
      this.menuLabel = label;
    },
  },
  mounted() {
    if (
      this.$store.state.componentName == "" ||
      this.$store.state.componentName == "Library Management"
    ) {
      this.showMenu("Library Management");
    } else {
      this.showMenu(this.$store.state.componentName);
    }
    this.fetchData();
  },
};
</script>

<style scoped>
.fillter_group_box:hover {
  cursor: pointer !important;
}
.on {
  color: #e25a09;
}
</style>
